import styled from 'styled-components'

export const StyledBackgroundImage = styled.div`
  width: 100%;
  background-image: url('${({ src }) => src}');
  height: 75px;
  border-bottom-left-radius: 0.688rem;
  border-bottom-right-radius: 0.688rem;
`
